var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alwaysShow || _vm.total > _vm.pageSize)?_c('div',{staticClass:"app-pagination"},[_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next","current-page":_vm.page,"page-size":_vm.pageSize,"total":_vm.total,"pager-count":5,"disabled":_vm.loading},on:{"current-change":_vm.handlePageChange}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }